import React from "react";
import { Typography, Space } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

const priceRangeData = [
  { range: "1.5M-2M", count: 2 },
  { range: "2M-3M", count: 5 },
  { range: "3M-4M", count: 8 },
  { range: "4M-5M", count: 6 },
  { range: "5M-6M", count: 4 },
  { range: "6M+", count: 2 },
];

const NeighborhoodOverviewCard = () => {
  return (
    <CustomCard
      title={
        <Space>
          <HomeOutlined />
          <span>Neighborhood Overview</span>
        </Space>
      }
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <Title level={4}>Price Range</Title>
          <Text>
            Nearby homes have sold for a wide range of prices, from about $1.8
            million to over $6 million.
          </Text>
        </div>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={priceRangeData}>
            <XAxis dataKey="range" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="count" fill="#97c23c" />
          </BarChart>
        </ResponsiveContainer>
        <div>
          <Title level={4}>Neighborhood Diversity</Title>
          <Text>
            The wide range of home prices indicates a diverse neighborhood with
            various types of properties, including:
          </Text>
          <ul>
            <li>Luxury beachfront villas</li>
            <li>Hillside estates with ocean views</li>
            <li>More modest single-family homes</li>
            <li>Some high-end condos or townhouses</li>
          </ul>
        </div>
        <Text type="secondary">
          This diversity can be attractive to different types of buyers and may
          contribute to the area's overall stability and appeal.
        </Text>
      </Space>
    </CustomCard>
  );
};

export default NeighborhoodOverviewCard;
